import React from 'react';
import StorefrontPage from '../../components/core/StorefrontPage';
import { StorefrontCheckoutContainer } from './containers/storefront-checkout.container';

/**
 * StorefrontCheckoutShellPage — public storefront checkout shell.
 * Wires StorefrontCheckoutContainer into the /shop/checkout OpenRoute.
 */
const StorefrontCheckoutShellPage: React.FC = () => {
    return (
        <StorefrontPage>
            <StorefrontCheckoutContainer />
        </StorefrontPage>
    );
};

export default StorefrontCheckoutShellPage;
